import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import {
  selectCredentialClientEndpoint,
  selectCredentialLeakDate,
  selectCredentialLinkedVulns,
  selectCredentialOwned,
  selectCredentialPassword,
  selectCredentialUsername,
  selectErrorCreateCredential
} from 'store/Credentials/selectors';
import { setCredentialField } from 'store/Credentials/actions';
import ModalWrapper from 'Common/Components/ModalWrapper';
import Header from './components/Header';
import CheckBox from 'Common/Components/Checkbox';
import {
  Wrapper,
  Row,
  Password,
  TextField,
  CheckBoxWrapper,
  Label,
  Content
} from './styled';
import LinkedVulns from './components/LinkedVulns';
import CreationWarning from './components/CreationWarning';
import LeakDate from './components/LeakDate';

const CreateEditModal = ({ isVulnDetail }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const username = useSelector(selectCredentialUsername);
  const clientEndpoint = useSelector(selectCredentialClientEndpoint);
  const password = useSelector(selectCredentialPassword);
  const leakDate = useSelector(selectCredentialLeakDate);
  const owned = useSelector(selectCredentialOwned);
  const vulns = useSelector(selectCredentialLinkedVulns);
  const showErrorCantCreate = useSelector(selectErrorCreateCredential);

  const onChange = (field, value) => dispatch(setCredentialField(field, value));

  return (
    <ModalWrapper>
      <Wrapper autoComplete="off">
        <Header isVulnDetail={ isVulnDetail } />
        <Content>
          <Row>
            <TextField
              title={ intl.formatMessage({
                id: 'credentials.modalCreateEdit.username'
              }) }
              autoComplete="new-credential-username"
              name="credential-username"
              id="credential-username"
              value={ username }
              onChange={ (value) => onChange('username', value) }
              isRequired
              placeholder="example@email.com"
            />
            <TextField
              title={ intl.formatMessage({
                id: 'credentials.modalCreateEdit.endpoint'
              }) }
              autoComplete="new-credential-client-endpoint"
              name="credential-client-endpoint"
              id="credential-client-endpoint"
              value={ clientEndpoint }
              onChange={ (value) => onChange('endpoint', value) }
              placeholder="https://myendpopint.com"
            />
          </Row>
          <Row>
            <Password
              title={ intl.formatMessage({
                id: 'credentials.modalCreateEdit.password'
              }) }
              autocomplete="new-password"
              name="credential-password"
              id="credential-password"
              value={ password }
              defaultValue={ password }
              onChange={ (value) => onChange('password', value) }
              type="password"
              placeholder="**********"
            />
            <LeakDate
              onChange={ (v) => onChange('leak_date', v) }
              title={ intl.formatMessage({
                id: 'credentials.modalCreateEdit.leakDate'
              }) }
              value={ leakDate }
            />
            <CheckBoxWrapper>
              <CheckBox
                checked={ owned }
                onChange={ () => onChange('owned', !owned) }
                state={ owned }
              />
              <Label>Owned</Label>
            </CheckBoxWrapper>
          </Row>
          { !isVulnDetail
            ? <LinkedVulns
                vulns={ vulns }
                isVulnDetail={ isVulnDetail }
                setLinkedVuln={ (linkedVulns) =>
                  dispatch(setCredentialField('vulnerabilities', linkedVulns))
                }
            />
            : null
          }
        </Content>
      </Wrapper>
      {showErrorCantCreate && <CreationWarning />}
    </ModalWrapper>
  );
};

export default CreateEditModal;
